"use strict";

export default {
    stores: [
        "MTTempImage",
        "MTSettings",
        "MTTasks",
        "MTTempData"
    ]
};


// WEBPACK FOOTER //
// ./src/js/Sync/config.js